import { regexEmail } from "@api";
import { type FocusEventHandler, type KeyboardEventHandler, useEffect, useState } from "react";

const CONFIRM_KEYS = ["Enter", "Tab", " "];
const REMOVE_KEYS = ["Backspace"];

export const useEmailField = (value?: string[], onChange?: (value: string[]) => void) => {
  const [text, setText] = useState("");
  const [contacts, setContacts] = useState<string[]>([]);
  const [focus, setFocus] = useState(false);

  const handleAdd = (value: string) => {
    const email = value.trim();
    if (!regexEmail.test(email)) {
      return;
    }
    setContacts((contacts) => {
      if (contacts.includes(email)) {
        return contacts;
      }
      const newContacts = [...contacts, email];
      if (onChange) {
        onChange(newContacts);
      }
      setText("");
      return newContacts;
    });
  };

  const handleDelete = (index: number) => {
    setContacts((contacts) => {
      const newContacts = contacts.filter((_, currentIndex) => currentIndex !== index);
      if (onChange) {
        onChange(newContacts);
      }
      return newContacts;
    });
  };

  const handleKeyDown: KeyboardEventHandler<HTMLInputElement | HTMLTextAreaElement> = (evt) => {
    const value = evt.currentTarget.value;
    if (CONFIRM_KEYS.includes(evt.key)) {
      evt.stopPropagation();
      evt.preventDefault();
      handleAdd(value);
    } else if (REMOVE_KEYS.includes(evt.key) && contacts.length > 0 && text.length === 0) {
      evt.stopPropagation();
      evt.preventDefault();
      handleDelete(contacts.length - 1);
    }
  };

  const handleFocus: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement> = () => {
    setFocus(true);
  };

  const handleBlur: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement> = () => {
    handleAdd(text);
    setText("");
    setFocus(false);
  };

  useEffect(() => {
    if (value) {
      setContacts(value);
    }
  }, [value]);

  return { text, setText, focus, contacts, handleDelete, handleKeyDown, handleFocus, handleBlur };
};
